import React, { useEffect, useState } from 'react'
import { Link, useHistory } from "react-router-dom";
import { ArrowBackIcon } from "~/Components/Icons/Icons";
import { adminHttp } from "~/Admin/services/http";
import { connect } from "react-redux";
import Layout from "~/Admin/Layout/Layout";
import useEffectSkipFirst from '../../Hooks/useEffectSkipFirst';

const AdminViewEmail = ({ event, match, ...props }) => {

    const [email, setEmail] = useState(null);
    const endpoint = '/events/' + event.id + '/emails/' + match.params.id;

    const history = useHistory();

    const loadData = () => {
        adminHttp
            .get(endpoint)
            .then(res => {
                setEmail(res.data);
            });
    };

    useEffectSkipFirst(() => {
        history.push('/communication');
    }, [event]);

    useEffect(() => {
        loadData()
    }, []);

    if (!email) {
        return <></>
    }

    return (
        <Layout>
            <div>
                <Link to="/communication" className="btn btn-secondary btn-sm mb-4">
                    <ArrowBackIcon classes="d-inline mr-2" />
                    Back
                </Link>

                <div className="row">
                    <div className="col-6">
                        <h2>Email #{email.id}</h2>
                    </div>
                </div>

                <div className="card shadow-sm bg-white mt-1">
                    <div className="card-body">
                        <table className="table">
                            <tr>
                                <th>Subject</th>
                                <td>{email.subject}</td>
                            </tr>
                            <tr>
                                <th>Name</th>
                                <td>{email.name}</td>
                            </tr>
                            <tr>
                                <th>Email</th>
                                <td>{email.email}</td>
                            </tr>
                            <tr>
                                <th>Cc</th>
                                <td>{email.cc}</td>
                            </tr>
                            <tr>
                                <th>Language</th>
                                <td>{email.language?.name || '-'}</td>
                            </tr>
                            <tr>
                                <th>Sender</th>
                                <td>{email.sender ? email.sender.full_name : '-'}</td>
                            </tr>
                            <tr>
                                <th>Type</th>
                                <td>{email.type}</td>
                            </tr>
                            <tr>
                                <th>Status</th>
                                <td>{email.status}</td>
                            </tr>
                        </table>
                    </div>
                </div>

                <h3 className="mt-1">Email preview:</h3>
                <div className="card shadow-sm bg-white">
                    <div className="card-body">
                        {email.html_preview && (
                            <div dangerouslySetInnerHTML={{ __html: email.html_preview }}></div>
                        )}

                        {!email.html_preview && (
                            <p>No preview is available!</p>
                        )}
                    </div>
                </div>
            </div>
        </Layout>
    );
}

const mapStateToProps = (state) => ({
    user: state.auth?.user,
    event: state.event.current,
});

export default connect(mapStateToProps)(AdminViewEmail);
